<script>
import NavBar from '@components/nav-bar/nav-bar.vue';
import { adminPanelComputed, alertComputed } from '@state/helpers';
const ClientConfirmationModal = () =>
  import(
    /* webpackChunkName: "ClientConfirmationModal" */ '@components/modals/client-confirmation-modal.vue'
  );
const ConfirmationModal = () =>
  import(
    /* webpackChunkName: "ConfirmationModal" */ '@components/modals/confirmation-modal.vue'
  );
const ConfirmationProgramClientModal = () =>
  import(
    /* webpackChunkName: "ConfirmationProgramClientModal" */ '@components/modals/confirmation-program-client-modal.vue'
  );
const DragConfirmationModal = () =>
  import(
    /* webpackChunkName: "DragConfirmationModal" */ '@components/modals/drag-confirmation-modal.vue'
  );
const FullsizeImageModal = () =>
  import(
    /* webpackChunkName: "FullsizeImageModal" */ '@components/modals/fullsize-image-modal.vue'
  );
const ItemSelectModal = () =>
  import(
    /* webpackChunkName: "ItemSelectModal" */ '@components/modals/item-select-modal.vue'
  );
const NotifyModal = () =>
  import(
    /* webpackChunkName: "NotifyModal" */ '@components/modals/notify-modal.vue'
  );
const OnboardingModal = () =>
  import(
    /* webpackChunkName: "OnboardingModal" */ '@components/modals/onboarding-modal.vue'
  );
const ProgramOverrideModal = () =>
  import(
    /* webpackChunkName: "ProgramOverrideModal" */ '@components/modals/program-override-modal.vue'
  );
const SubscriptionClientModal = () =>
  import(
    /* webpackChunkName: "SubscriptionClientModal" */ '@components/modals/subscription-client-modal.vue'
  );
const UnsavedChangesModal = () =>
  import(
    /* webpackChunkName: "UnsavedChangesModal" */ '@components/modals/unsaved-changes-modal.vue'
  );
const WorkoutErrorModal = () =>
  import(
    /* webpackChunkName: "WorkoutErrorModal" */ '@components/modals/workout-error-modal.vue'
  );
const ImportContactsWizard = () =>
  import(
    /* webpackChunkName: "ImportContactsWizard" */ '@components/modals/import-contacts-wizard.vue'
  );
const ConfrimEnrollment = () =>
  import(
    /* webpackChunkName: "ConfrimEnrollment" */ '@components/modals/confirm-enrollment-modal.vue'
  );

export default {
  components: {
    ClientConfirmationModal,
    ConfirmationModal,
    ConfirmationProgramClientModal,
    DragConfirmationModal,
    FullsizeImageModal,
    ItemSelectModal,
    NavBar,
    NotifyModal,
    OnboardingModal,
    ProgramOverrideModal,
    SubscriptionClientModal,
    UnsavedChangesModal,
    WorkoutErrorModal,
    ImportContactsWizard,
    ConfrimEnrollment,
  },
  computed: {
    ...adminPanelComputed,
    ...alertComputed,
  },
};
</script>

<template>
  <div
    :class="[
      'container',
      {
        'admin-panel-active': isAdminPanelActive,
        'with-banner': showAlertBanner,
      },
    ]"
  >
    <ConfirmationModal />
    <OnboardingModal />
    <ConfirmationProgramClientModal />
    <WorkoutErrorModal />
    <ProgramOverrideModal />
    <ItemSelectModal />
    <FullsizeImageModal />
    <SubscriptionClientModal />
    <NotifyModal />
    <NavBar />
    <ClientConfirmationModal />
    <UnsavedChangesModal :fromPanel="isAdminPanelActive" />
    <DragConfirmationModal />
    <ImportContactsWizard />
    <ConfrimEnrollment />
    <slot />
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.container {
  height: 100%;
  margin: 0 auto;
  max-width: 100%;
  min-width: $size-content-width-min;
  overflow: hidden;
  padding: 0;
  position: relative;
}
</style>
